import type {CssValue} from '../../constants'
import {splitValue} from './split'

interface CssFunction {
    name: string
    args: string[]
}

export const OPENING_BRACKETS = '('
export const CLOSING_BRACKETS = ')'
export const ARGS_DELIMITER = ','

const isFunctionValid = (func: string | undefined, name: string, args: string): boolean => {
    if (!func) {
        return false
    }

    let bracketsCounter = 0
    for (const char of args) {
        if (char === OPENING_BRACKETS) {
            bracketsCounter++
        } else if (char === CLOSING_BRACKETS) {
            if (bracketsCounter === 0) {
                return false
            }

            bracketsCounter--
        }
    }

    return bracketsCounter === 0
}

export const serializeFunction = (func: CssFunction): CssValue => {
    const {name, args} = func
    return `${name}(${args.join(ARGS_DELIMITER)})`
}

export const deserializeFunction = (val: CssValue): CssFunction | undefined => {
    const [funcMatch, name, argsString] = val.match(/^([a-zA-Z0-9_-]+)\((.*)\)$/) ?? []

    if (!isFunctionValid(funcMatch, name, argsString)) {
        return undefined
    }

    if (argsString === '') {
        return {name, args: []}
    }

    const args = splitValue(argsString, ARGS_DELIMITER).map(arg => arg.trim())

    if (args.some(arg => arg === '')) {
        return undefined
    }

    return {name, args}
}
